import { ArrowSquareOutIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ExternalLink = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <ArrowSquareOutIcon color={fill} size={Sizes[size]} {...rest} />;
};

ExternalLink.displayName = 'ExternalLink';
